import { render, staticRenderFns } from "./SingleSummary.vue?vue&type=template&id=374047a8&scoped=true&"
import script from "./SingleSummary.vue?vue&type=script&lang=ts&"
export * from "./SingleSummary.vue?vue&type=script&lang=ts&"
import style0 from "./SingleSummary.vue?vue&type=style&index=0&id=374047a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374047a8",
  null
  
)

export default component.exports